/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MaterialThumbnail from 'components/consumer/MaterialThumbnail';

const SIZE_TEXT_CLASS = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-base',
};

const ActiveFabricSummary = React.forwardRef(
  (
    {
      selectedOption,
      size = 'md',
      materialNameClass = '',
      fullHeight = false,
      showThumbnail = true,
      nameDataXc = 'ActiveFabricSummary-name',
      rowDataXc,
      className = '',
      onClick,
      role,
      tabIndex,
      ariaLabel,
      title,
      children,
    },
    ref
  ) => {
    if (!selectedOption) {
      return null;
    }

    const name = selectedOption.label || selectedOption.value;

    return (
      <div className="flex justify-start">
        <div
          ref={ref}
          data-xc={rowDataXc}
          className={classNames(
            'flex items-center pr-0.5 mb-2 lg:mb-1.5',
            className
          )}
          onClick={onClick}
          role={role}
          tabIndex={tabIndex}
          aria-label={ariaLabel}
          title={title}
        >
          {showThumbnail && (
            <div className="w-4 h-4 mr-1">
              <MaterialThumbnail
                image={selectedOption.image}
                label={name}
                materialId={selectedOption.materialId}
                upholsteryOptionId={selectedOption.upholsteryOptionId}
                description={selectedOption.description}
                isRound
                fullHeightThumbnail={fullHeight}
              />
            </div>
          )}

          <div
            className={classNames('leading-4 [&_*]:inline [&_*]:leading-4', {
              'mx-1': showThumbnail,
            })}
          >
            <h3
              data-xc={nameDataXc}
              className={classNames(
                'hover:underline font-bold',
                materialNameClass,
                {
                  [SIZE_TEXT_CLASS[size]]: true,
                  inline: !materialNameClass,
                }
              )}
            >
              {name}
              {selectedOption.exclude_from_sale ? ' - Limited Edition' : null}
            </h3>
            {children}
          </div>
        </div>
      </div>
    );
  }
);

ActiveFabricSummary.displayName = 'ActiveFabricSummary';

ActiveFabricSummary.propTypes = {
  selectedOption: PropTypes.shape({
    exclude_from_sale: PropTypes.bool,
    description: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string,
    materialId: PropTypes.number,
    upholsteryOptionId: PropTypes.number,
    value: PropTypes.string,
  }),
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  materialNameClass: PropTypes.string,
  fullHeight: PropTypes.bool,
  showThumbnail: PropTypes.bool,
  nameDataXc: PropTypes.string,
  rowDataXc: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  role: PropTypes.string,
  tabIndex: PropTypes.string,
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
};

export default ActiveFabricSummary;
